module.exports = __webpack_public_path__ + "img/luthi-10.a7a092c5.jpg";